import { HttpService } from '@/infra/http'
import type { TClienteSimplificado, TTelefone } from '@/types/cliente'
import type { TPaginatedResponse } from '@/types/paginacao'

export type TGetListaDeClientesParams = {
  nome?: string | null
  cpf?: string | null
  telefone?: TTelefone['numero'] | null
  vendedorAlocadoId?: string | null
  tamanhoDaPagina?: number | null
  paginaCorrente?: number | null
  origem?: TTelefone['origem'] | null
}

export class GetListarClientesService extends HttpService {
  async execute(params: TGetListaDeClientesParams): Promise<TPaginatedResponse<TClienteSimplificado>> {
    const response = await this.http.get<TPaginatedResponse<TClienteSimplificado>>('api/v2/Cliente/lista', { params })
    return response.data
  }
}
